import { Toast } from 'bootstrap';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../../../utils/apiCalling';
import { config } from '../../../utils/apiUrl';
import "./subscribe.css";
import { toast } from "react-toastify"
import SubscribeModalImg from '../../../components/common/subscribeModalImg';
import SpeakModal from '../../WarrantEducation/SuccessSpeak/SpeakModal'
import validator from 'validator'

const Subscribes = (props) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const api = new API()

    const [email, setEmail] = useState();
    const [openLive, setOpenLive] = useState(false)
    const [openMsg, setOpenMsg] = useState(false)
    const [emailMsg, setEmailMsg] = useState(false)
    const [ready, setReady] = useState(false)

    const validateEmail = (e) => {
        var email = e.target.value

        if (validator.isEmail(email)) {
            setEmail(email)
        } else {
            setEmailMsg(true)
            setEmail()
        }
    }

    function valueSubmit(e) {
        if (!email) {
            setEmailMsg(true)
        }
        else {
            if(ready){
                submit(e)
            }
        }
    }

    const submit = async (e) => {
        e.preventDefault();
        let data = {
            email
        }
        let res = await api.post(`${config.subscription}${"?p=register"}`, data)
            .then((res) => {
                setOpenMsg(true)
                setTimeout(() => setOpenMsg(false), [2500])
            })
            .catch((error) => console.log(error))
    }
    return (
        <>
            <div id="subscribe" className="pageobj">
                <div className="breadcrumbbar">
                    <div className="container-fluid">
                        <ol className="breadcrumb">
                            <li>
                                <Link to="/home?news">Market news </Link>
                            </li>
                            <li className="active">Subscribe </li>
                        </ol>
                    </div>
                </div>
                <div className="stripe-bg" />
                <div className="container-fluid sub_bg_img">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="section">
                                <h3><b>Follow us</b></h3>
                                <div >
                                    Keep up to date with the latest market news by following us on social media!
                                </div>
                                <img src="/img/marketnews/image212.png" className='sub_tab_img' alt="" />
                                <hr style={{ marginBottom: '50px'}}/>
                                <div >
                                    Click the social icons to join our channels!
                                </div>
                                <div style={{marginTop:'15px'}}>
                                    <div className='main_box'>
                                        <div className='main_flex'>
                                            <div className='main_flex'>
                                                <a href="https://www.facebook.com/MalaysiaWarrants" target='_blank'>
                                                <img src="/img/marketnews/5_Black_circle_Icon_1.png" alt="" className='sub_img'/>
                                                </a>
                                                <div className='flex_margin'>
                                                    <div>Facebook</div>
                                                    <div>MalaysiaWarrants</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='main_box'>
                                        <div className='main_flex'>
                                            <div className='main_flex'>
                                                <a href="https://t.me/Malaysiawarrants" target='_blank'>
                                                <img src="/img/marketnews/6_Black_circle_Icon_2.png" alt="" className='sub_img'/>
                                                </a>
                                                <div  className='flex_margin'>
                                                    <div>Telegram</div>
                                                    <div>MacquarieWarrantsMalaysia</div>
                                                </div>
                                            </div>
                                            <div  className='sub_learm_btm'>
                                                <a href="/telegram" target='_blank'>
                                                    <img src="/img/marketnews/7_Learn_more.png" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='main_box'>
                                        <div className='main_flex'>
                                            <div className='main_flex'>
                                                <a href="https://www.moomoo.com/community/profile/macquarie-warrants-malaysia-80001374" target='_blank'>
                                                <img src="/img/marketnews/6_Black_circle_Icon_3.png" alt="" className='sub_img'/>
                                                </a>
                                                <div  className='flex_margin'>
                                                    <div>MooCommunity</div>
                                                    <div>MacquarieWarrantsMalaysia</div>
                                                </div>
                                            </div>
                                            <div  className='sub_learm_btm'>
                                                <a href="/moocommunity" target='_blank'>
                                                    <img src="/img/marketnews/7_Learn_more.png" alt="" />
                                                </a>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="section sub_nobg">
                                <div className="content-layer">
                                        <h3><b>Sign up for Macquarie's newsletter</b> </h3>
                                        <div style={{position:'relative'}}>
                                                <img src="/img/marketnews/8_View_sample.png" alt="" className='banner_img' onClick={() => setOpenLive(true)}/>
                                            <p className='banner_title'>
                                            Get highlights of major 
                                            <br />
                                            news events and updates 
                                            <br />
                                            from the warrant market
                                            </p>
                                        </div>
                                    <div className="shadow-layer">
                                        <div className="signup-layer">
                                            <div>Email</div>   
                                            <input
                                                type="text"
                                                id="email"
                                                name="email"
                                                value={email}
                                                onChange={(e) => {
                                                    validateEmail(e)
                                                    setEmailMsg(false)
                                                }}
                                                placeholder="Enter a valid email address" />
                                            <div className="warning">
                                                {emailMsg && <span>Invalid email</span>}
                                            </div>
                                            <p className="small">
                                                By clicking “Submit”, you confirm that you would like to
                                                receive Macquarie’s daily newsletter and invitations for
                                                warrant seminars, and you acknowledge that Macquarie’s website
                                                administrators may have access to your personal data for the
                                                processing of such data on behalf of Macquarie Capital
                                                Securities Malaysia Sdn Bhd and other companies of Macquarie
                                                group (“Macquarie”). You may view Macquarie’s privacy policy
                                                with regard to collection and management of personal data via
                                                the links at the bottom of this page.
                                                <br />
                                                <br />
                                                <input className="agreechckbox" type="checkbox" style={{marginRight:'5px'}} onChange={(e)=>{setReady(e.target.checked)}} checked={ready}/>
                                                Tick here if you agree to allow Macquarie to use your personal
                                                data for purposes of marketing and advertising of financial
                                                products (including using your data for market research and
                                                analysis and sending focus group invitations to you).
                                                <br />
                                                <br />
                                            </p>
                                            <button
                                                id="submitBtn"
                                                style={{background:'#00B7FC',color:'#fff'}}
                                                onClick={(e) => valueSubmit(e)}
                                            >Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SubscribeModalImg Open={openLive} OpenModel={() => setOpenLive(!true)} />
            <div id="popup-customized" className="subscribe" style={{ display: "none" }}>
                <div>
                    <h5>You have successfully registered for our daily newsletter!</h5>
                </div>
            </div>
            {openMsg && <SpeakModal open={openMsg} />}
        </>
    );
}
export default Subscribes;
